import axiosInstance from '../utils/axiosConfig';
import { PurchaseBundleRequest, PaymentResponseDTO } from '../types/payment';

export const paymentApi = {
  getBundles: async () => {
    const response = await axiosInstance.get('/api/bundles/active-bundles')
    return response.data
  },

  validatePromoCode: async (code: string, bundleId?: string) => {
    console.log(code)
    const response = await axiosInstance.get('/api/promo-codes/validate', {
      params: { code, bundleId },
    })
    return response.data
  },

  PurchaseBundle: async (bundleId: string, promoCode?: string) => {
    const request: PurchaseBundleRequest = {
      bundleId,
      ...(promoCode && { promoCode })
    };
    
    const response = await axiosInstance.post('/api/payments/purchase', request)
    return response.data
  },
  
  verifyPayment: async (paymentData: PaymentResponseDTO) => {
    const response = await axiosInstance.put('/api/payments/verify', paymentData)
    return response.data
  },
  
  cancelPayment: async (paymentId: string) => {
    const response = await axiosInstance.put('/api/payments/cancel', null, {
      params: { paymentId }
    })
    return response.data
  }
}